<template>
  <OrderList :customer="''"/>
</template>

<script>
import OrderList from '@/components/documents/OrderList.vue'

export default {
  name: 'OrdersView',
  components: {
    OrderList
  }
}
</script>
